import React, { useEffect, useState } from "react";
import { siteRoutes } from "utils/helpers/enums/routes";
import { useSelector } from "react-redux";
import AmbassadorBreadcrumb, { AmbassadorBreadcrumbLink } from "components/breadcrumbs/AmbassadorBreadcrumb";
import useAmbassador from "../useHooks";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { BAGDE_TYPES } from "utils/helpers/enums/shared.enum";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import badgeNotFoundGif from "assets/images/gifs/badge-not-found.gif";
import Pagination from "components/pagination";

const MyBadges: React.FC = () => {
  const breadcrumbLinks: AmbassadorBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.ambassadorHome },
    { title: "My Badges", path: siteRoutes.ambassadorMyBadges },
  ];

  const [data, setData] = useState<any[]>([]);
  const [filters, setFilters] = useState({
    page: 0,
    size: 10,
    totalElements: 0,
  });
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const { getAmbassadorBadges } = useAmbassador();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const loadBadges = (page = 0, size = 10) => {
    const queryParams = {
      page,
      size,
      badgeType: BAGDE_TYPES?.ACHIEVEMENT,
    };
    getAmbassadorBadges(setData, queryParams, setFilters);
  };

  const handlePageChange = ({
    selected,
    limit,
  }: {
    selected: number;
    limit: number;
  }) => {
    loadBadges(selected, limit);
  };

  useEffect(() => {
    loadBadges();
  }, []);

  // Mark initial load as complete when loading finishes
  useEffect(() => {
    if (isInitialLoad && !isLoading) {
      setIsInitialLoad(false);
    }
  }, [isLoading, isInitialLoad]);

  return (
    <div className="container min-h-[70vh]">
      <AmbassadorBreadcrumb links={breadcrumbLinks} />
      <div className="w-full flex justify-between gap-4">
        <h2 className="text-2xl font-bold mb-4 text-blackie">My Badges</h2>
        {/* <button
          onClick={() => {
            navigate(siteRoutes.createBadge);
          }}
          className="px-8 text-sm bg-yellowText text-white rounded-lg font-semibold"
        >
          Add Badge
        </button> */}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {data.length > 0
          ? data.map((badge, index) => (
              <div
                key={index}
                className={`relative flex flex-col items-center justify-center p-6 cursor-pointer border rounded-[8px]`}
              >
                <img
                  className="w-[98px] min-h-[108px] object-cover transition-transform duration-200 hover:scale-105"
                  src={concatPathWithBackendUrl(badge.image?.name || badge.imageUrl)}
                  alt={badge.name || badge.badgeType}
                />
                <span className="text-lg font-semibold mt-3 text-black capitalize">
                  {badge.name || badge.badgeType}
                </span>
              </div>
            ))
          : null}
      </div>

      <CustomMessageDisplay
        show={!isLoading && !data.length && !isInitialLoad}
        title="No Badges Available"
        slogan="You don't have any badges yet. Complete achievements to earn badges!"
        image={badgeNotFoundGif}
        imageAlt="No badges found"
        className="py-12"
        imageClassName="w-[150px] h-[120px]"
        titleClassName="text-2xl font-bold text-blackie"
        sloganClassName="text-gray-500 text-base"
      />

      {data.length > 0 && filters.totalElements > filters.size && (
        <Pagination
          count={filters.totalElements}
          page={filters.page}
          limit={filters.size}
          onPageChange={handlePageChange}
          activeBgColor={"#37588A"}
          activeTextColor={"#ffffff"}
        />
      )}
    </div>
  );
};

export default MyBadges;
